const firebaseConfig = {
  apiKey : "AIzaSyD6jguoCz0waQ0MtV4HVicXAkMH4gC3ABc" , 
  authDomain : "tourism-website-4a770.firebaseapp.com" , 
  projectId : "tourism-website-4a770" , 
  storageBucket : "tourism-website-4a770.appspot.com" , 
  messagingSenderId : "607449074770" , 
  appId : "1: 607449074770: web: a85d028eff0d0efc9fe38b" 
  };

export default firebaseConfig;